import { ReactNode } from 'react';

import { Nullable, SimpleImage, TimelineEventFields } from '@boss/types/corporate-jobs';

import ComponentMapper from '../ComponentMapper';

const getTimelineEventProps = (
  entry: TimelineEventFields,
  locale: string,
): {
  image: Nullable<SimpleImage>;
  content: ReactNode;
  year: number;
} => {
  const { year, image, content } = entry;

  return {
    image: {
      id: image.id,
      imageUrl: image?.image?.file?.url,
      imageAlt: image?.image?.title,
    },
    content: content ? <ComponentMapper entry={content} locale={locale} /> : null,
    year: parseInt(year),
  };
};

export default getTimelineEventProps;
